import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'buffer';
// import { Provider } from "react-redux";
// import {store} from "./appRedux/store/store"

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

  // <Provider store={store}>
  <>
 <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
 </React.StrictMode>
  </>

  // </Provider>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
